import { render } from "./drivers-list.vue?vue&type=template&id=2a9dd030"
import script from "./drivers-list.vue?vue&type=script&lang=js"
export * from "./drivers-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__